/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import classnames from 'classnames';

import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import { INosLinkListData } from './nos-link-list.data';
import { INosLinkListProps } from './nos-link-list.props.autogenerated';

export interface INosLinkListViewProps extends INosLinkListProps<INosLinkListData> {
    linkList: INodeProps;
    className: string;
}

/**
 *
 * NosLinkList component
 * @extends {React.PureComponent<INosLinkListViewProps<INosTextBlockProps>>}
 */

class NosLinkList extends React.PureComponent<INosLinkListProps<INosLinkListData>> {
    private readonly className = 'nos-link-list';
    public render(): JSX.Element | null {
        const viewProps = {
            ...this.props,
            linkList: this._renderLinkList(),
            className: classnames(this.className)
        };

        return this.props.renderView(viewProps);
    }

    private _renderLinkList = () => {
        const { config } = this.props;

        return (
            <>
                {config?.linkList?.map((el, index) => {
                    const icon = el.pictogram && (
                        <div className={`${this.className}__pictogram`} dangerouslySetInnerHTML={{ __html: el.pictogram }} />
                    );
                    if (el.link?.linkUrl.destinationUrl) {
                        return (
                            <li className={`${this.className}__item`} key={index}>
                                {icon}

                                <p className={`${this.className}__text`}>
                                    <a
                                        href={el?.link?.linkUrl?.destinationUrl}
                                        aria-label={el?.link?.ariaLabel}
                                        target={el?.link?.openInNewTab ? '_blank' : ''}
                                        rel='noreferrer'
                                    >
                                        {el.text}
                                    </a>
                                </p>
                            </li>
                        );
                    }

                    return (
                        <li className={`${this.className}__item`} key={index}>
                            {icon}
                            <p className={`${this.className}__text`}>{el.text}</p>
                        </li>
                    );
                })}
            </>
        );
    };
}

export default NosLinkList;
